import { useState } from "react";
import Front_1 from "../../common/images/fi-1.png";
import Front_2 from "../../common/images/fi-2.png";
import Front_3 from "../../common/images/fi-3.png";
import Front_4 from "../../common/images/fi-4.png";
import Front_5 from "../../common/images/fi-5.png";
import backend_1 from "../../common/images/backend-1.png";
import backend_2 from "../../common/images/backend-2.png";
import backend_3 from "../../common/images/backend-3.png";
import backend_4 from "../../common/images/backend-4.png";
import backend_5 from "../../common/images/backend-5.png";
import cms_1 from "../../common/images/cms-1.png";
import cms_2 from "../../common/images/cms-2.png";
import cms_3 from "../../common/images/cms-3.png";
import cms_4 from "../../common/images/cms-4.png";
import cms_5 from "../../common/images/cms-5.png";
import dataBase_1 from "../../common/images/database-1.png";
import dataBase_2 from "../../common/images/database-2.png";
import dataBase_3 from "../../common/images/database-3.png";
import dataBase_4 from "../../common/images/database-4.png";
import dataBase_5 from "../../common/images/database-5.png";
import cloud_1 from "../../common/images/cloud-1.png";
import cloud_2 from "../../common/images/cloud-2.png";
import cloud_3 from "../../common/images/cloud-3.png";
import cloud_4 from "../../common/images/cloud-4.png";
import cloud_5 from "../../common/images/cloud-5.png";
const techCategories = [
  {
    name: "Frontend",
    technologies: [Front_1, Front_2, Front_3, Front_4, Front_5],
  },
  {
    name: "Backend",
    technologies: [backend_1, backend_2, backend_3, backend_4, backend_5],
  },
  {
    name: "CMS",
    technologies: [cms_1, cms_2, cms_3, cms_4, cms_5],
  },
  {
    name: "Database",
    technologies: [dataBase_1, dataBase_2, dataBase_3, dataBase_4, dataBase_5],
  },
  {
    name: "Cloud",
    technologies: [cloud_1, cloud_2, cloud_3, cloud_4, cloud_5],
  },
];

export default function Technologies() {
  const [activeTab, setActiveTab] = useState(techCategories[0].name);

  return (
    <div className="bg-gradient-to-b from-blue-100 to-white">
      <div className="max-w-[1000px] mx-auto md:p-10 p-5 text-center">
        <h2 className="small:text-4xl text-3xl font-bold md:text-5xl">
          Technologies We Use
        </h2>
        <div className="underline w-1/5 flex justify-center mx-auto my-4 items-center h-[2px] rounded-md bg-secondary">
          <p className="h-[5px] rounded-xl bg-yellow-400 w-[50%]"></p>
        </div>
        <p className="font-semibold max-w-5xl mx-auto">
          We work with the latest tools and frameworks to build scalable and
          secure websites.
        </p>
        {/* Tabs */}
        <div className="flex justify-between mt-6 mb-0 border-b-[4px] border-gray-200">
          {techCategories.map((tab) => (
            <button
              key={tab.name}
              className={`small:text-lg  text-sm pb-2 px-1 capitalize font-semibold relative top-1 ${
                activeTab === tab.name
                  ? "text-secondary border-b-4  border-yellow-400 "
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab(tab.name)}
            >
              {tab.name}
            </button>
          ))}
        </div>
        {/* Content */}
        <div className="mt-6 grid small:grid-cols-5 grid-cols-3 justify-between gap-6">
          {techCategories
            .find((tab) => tab.name === activeTab)
            ?.technologies.map((tech, index) => (
              <div key={index} className="small:w-32 w-25 hover:animate-fliptopright ">
                <img
                  src={typeof tech === "string" ? tech : tech.image}
                  alt={tech.name || "Technology"}
                  className="size-full mx-auto "
                />
                {tech.name && <p className="mt-2 font-semibold">{tech.name}</p>}
              </div>
            ))}
        </div>
      </div>
    </div>
  );
}
